enum LifeStageDatePrecisionEnum {
    Day = 0,
    DayApprox = 1,
    MonthYear = 2,
    Year = 3
}

export { LifeStageDatePrecisionEnum };
